import { api } from './client'

export function fetchUsers() {
  return api.get('/users').then((r) => r.data)
}

export function createUser(body) {
  return api.post('/users', body).then((r) => r.data)
}

export function updateUser(id, body) {
  return api.put(`/users/${id}`, body).then((r) => r.data)
}

export function deactivateUser(id) {
  return api.put(`/users/${id}`, { is_active: false }).then((r) => r.data)
}

export function deleteUser(id) {
  return api.delete(`/users/${id}`).then((r) => r.data)
}
